import React, { useState } from "react";
import { DUCK_MASCOT_PNG_FALLBACK, DUCK_MASCOT_SVG } from "../constants/duckling";
import "./WalkingDuck.css";

/** One leg of the walk (L→R or R→L). Full round-trip = 2× this. */
const WALK_LEG_SEC = 32;

const PRIMARY_SRC = process.env.REACT_APP_DUCK_IMAGE_URL || DUCK_MASCOT_SVG;

/**
 * Subtle bottom-edge mascot: a small watercolor-style duck (not hero photography).
 * Ping-pongs left ↔ right so it feels part of the boutique UI, not pasted on.
 */
export default function WalkingDuck() {
    const [src, setSrc] = useState(PRIMARY_SRC);

    return (
        <div
            className="walking-duck"
            style={{ "--walk-leg-duration": `${WALK_LEG_SEC}s` }}
            aria-hidden
            data-testid="walking-duck"
        >
            <div className="walking-duck__walker">
                <div className="walking-duck__flip">
                    <img
                        src={src}
                        alt=""
                        className="walking-duck__sprite"
                        draggable={false}
                        onError={() => {
                            if (src !== DUCK_MASCOT_PNG_FALLBACK) {
                                setSrc(DUCK_MASCOT_PNG_FALLBACK);
                            }
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
